import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode; fallbackTitle?: string };
type State = { error: Error | null };

/** 捕获渲染/子树错误，避免整页白屏 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[TMA ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="app-shell" style={{ paddingTop: 40 }}>
          <img className="empty-ill" src="/ill/ill_secure.svg" alt="" style={{ maxWidth: 200 }} />
          <div className="error-box">
            <strong>{this.props.fallbackTitle || "页面出错"}</strong>
            <div style={{ marginTop: 8 }}>{this.state.error.message}</div>
          </div>
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => {
              this.setState({ error: null });
              window.location.href = "/";
            }}
          >
            返回首页
          </button>
          <button
            className="btn btn-ghost"
            type="button"
            style={{ marginTop: 10 }}
            onClick={() => window.location.reload()}
          >
            刷新页面
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
